// src/experiments/double-duration-all.mjs

import { Duration } from 'luxon';

/**
 * @type {Experiment}
 */
export const DoubleDurationAllExperiment = {
  id: 'double-duration-all',
  type: 'recurrence',
  name: 'Dobbelt gentagelsesvirkning. Også hastighed fordobles',
  exclusive: true,
  allowMultiple: false, // 🚨 Tillader eksplicit IKKE at køre flere gange!
  
  /**
   * @param {AppState} appState 
   * @returns {void}
   */
  init(appState) {
    console.log('[Eksperiment] Aktiveret: Dobbelt gentagelsesvirkning. Også hastighed fordobles...');
    
    // Registrer en ændring på featuren 'duration:alter'
    appState.registerModifier('duration:alter',
      /**
       * @param {PeriodDuration} originalDuration
       * @param {boolean} [isSpecialRecurrence]
       * @returns {PeriodDuration}
       */
      (originalDuration, isSpecialRecurrence) => {
        return /** @type {PeriodDuration} */ (
          Duration.fromObject(originalDuration)
            .plus(originalDuration)
            .toObject()
        );

    });
  }
};